__turbopack_context__.v({
  "fallback_spacing": "_3E4t1q_fallback_spacing",
  "page_transition": "_3E4t1q_page_transition",
});
